import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16px",
  height: "16px",
  viewBox: "0 0 10 16",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      stroke: "none",
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("polygon", {
        fill: "#ffffff",
        points: "0 2 6 8 0 14 2 16 10 8 2 0"
      })
    ], -1)
  ]))]))
}
export default { render: render }